import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router';
import JobSearchCard from '../JobSearchCard';
import Loader from '../Loader';

const JobSearchList = () => {

  const location = useLocation();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  const getQueryParams = (search) => {
    return new URLSearchParams(search);
  };
  useEffect(() => {
    const queryParams = getQueryParams(location.search);
    const keyword = queryParams.get('keyword') || '';
    const locationParam = queryParams.get('location') || '';
    const category = queryParams.get('category') || '';

    const fetchData = async () => {
      try {
        const url=`${process.env.REACT_APP_API_URL}jobs/search-jobs`
        const response = await axios.get(url,
          {
            params: {
              keyword,
              location: locationParam,
              category,
            },
          }
        );
        setJobs(response.data);
      } catch (error) {
        console.error("Error fetching search results:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [location.search]);
  return (
    <div className="job-area bg py-120">
  <div className="container">
    <div className="row">
      <div
        className="col-lg-6 mx-auto wow fadeInDown"
        data-wow-duration="1s"
        data-wow-delay=".25s"
        style={{
          visibility: "visible",
          animationDuration: "1s",
          animationDelay: "0.25s",
          animationName: "fadeInDown"
        }}
      >
        <div className="site-heading text-center">
          <span className="site-title-tagline">Recent Jobs</span>
          <h2 className="site-title">Find Your Dream Job</h2>
          <p>Know Your Worth And Find The Job That Qualify Your Life</p>
        </div>
      </div>
    </div>
    <div className="row">
          {loading ? (
            <Loader />
          ) : jobs && jobs.length > 0 ? (
            jobs.map((job) => <JobSearchCard job={job} key={job.id} />)
          ) : (
            <div className="site-heading text-center">
              <h2>No jobs available at the moment. Please check back later.</h2>
            </div>
          )}
        </div>
  </div>
</div>
  )
}

export default JobSearchList
